import { render } from "./AssessmentTypeManagement.vue?vue&type=template&id=7a72780e&scoped=true"
import script from "./AssessmentTypeManagement.vue?vue&type=script&lang=js"
export * from "./AssessmentTypeManagement.vue?vue&type=script&lang=js"

import "./AssessmentTypeManagement.vue?vue&type=style&index=0&id=7a72780e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a72780e"]])

export default __exports__